import SettingsStore from "SettingsStore";
import SymbolType from "SymbolType";
import { AiInsightsConstants } from "../Constants/AiInsightsConstants";
import { SettingsConstants } from "../Constants/SettingsConstants";
import TabAiInsightsSettings from "../Stores/ConsoleWindow/Settings/Modules/DataGraph/TabAiInsightsSettings";


const { ActionTypes } = AiInsightsConstants;

const initialState = {
  isReqActive: false,
  message: "Loading ...",
  aiInsightsCategories: [],
  aiInsightsSettings: new TabAiInsightsSettings(),
  aiInsightsSelectedReportTitle: "",
  aiInsightsSelectedReportData: "",
  isInsightReportFetched: false,
  lastGeneratedTime: null,
  selectedCategoryInBeta: false,
  applicableInstrumentsAiInsights: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ]
};

const AiInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MESSAGE:
      return {
        ...state,
        message: action.message,
      };

    case ActionTypes.GET_AI_INSIGHTS_CATEGORIES_REQUEST:
      return {
        ...state,
        message: "Loading ...",
        isReqActive: true,
      };

    case ActionTypes.GET_AI_INSIGHTS_CATEGORIES_SUCCESS:
    case ActionTypes.GET_AI_INSIGHTS_CATEGORIES_FAILURE:
      return {
        ...state,
        aiInsightsCategories: action.data,
        aiInsightsSettings: action.settings,
        message: action.message,
        isReqActive: false,
        selectedCategoryInBeta: action.isCurrentReportBeta
      };

    case ActionTypes.GET_AI_INSIGHTS_SELECTED_REPORT_DATA_REQUEST:
      state.aiInsightsSettings.selectedCategory = action.selectedCategory;
      state.aiInsightsSettings.selectedSubCategoryId = action.selectedSubCategoryId;
      SettingsStore.saveSettings();
      let isBeta = false;
      const subCategory = state.aiInsightsCategories.find((cat) => Object.keys(cat)[0] === action.selectedCategory)?.[action.selectedCategory]?.find((sc) => sc.id === action.selectedSubCategoryId);
      if (subCategory) {
        isBeta = subCategory.isBeta;
      } else {
        isBeta = false;
      }
      return {
        ...state,
        aiInsightsSelectedReportTitle: "",
        aiInsightsSelectedReportData: "",
        message: "Loading ...",
        isReqActive: true,
        isInsightReportFetched: false,
        selectedCategoryInBeta: isBeta
      };

    case ActionTypes.GET_AI_INSIGHTS_SELECTED_REPORT_DATA_SUCCESS:
    case ActionTypes.GET_AI_INSIGHTS_SELECTED_REPORT_DATA_FAILURE:
      return {
        ...state,
        aiInsightsSelectedReportData: action.data,
        message: action.message,
        isReqActive: false,
      };

    case ActionTypes.SET_AI_INSIGHTS_SELECTED_REPORT_TITLE:
      return {
        ...state,
        aiInsightsSelectedReportTitle: action.data,
        isInsightReportFetched: true,
        lastGeneratedTime: action.lastGeneratedTime
      }

    case SettingsConstants.ActionTypes.SYMBOL_CHANGE_EVENT:
      return {
        ...state,
        aiInsightsSelectedReportTitle: "",
        aiInsightsSelectedReportData: "",
        message: "Loading ...",
        isReqActive: true,
        isInsightReportFetched: false,
      }
    default:
      return state;
  }
};

export default AiInsightsReducer;
